import React from 'react';
import {
  Datagrid,
  TextField,
  EditButton,
  FunctionField,
  Pagination,
  useListController,
  useRedirect,
  ListContextProvider,
  ResourceContextProvider,
  DateField
} from 'react-admin';
import { Link } from '@mui/material';

interface Props {
  projectId: number;
}

const ContactCellLink: React.FC<{
  record?: { contactId?: number; contactFullName?: string };
}> = ({ record }) => {
  const redirect = useRedirect();
  if (!record?.contactId) return null;
  return (
    <Link
      underline="hover"
      sx={{ cursor: 'pointer' }}
      onClick={(e) => {
        e.stopPropagation();
        redirect('show', 'contacts', record.contactId);
      }}
    >
      {record.contactFullName || '-'}
    </Link>
  );
};

export const PaginatedProjectContacts: React.FC<Props> = ({ projectId }) => {
  const resource = 'project-contacts';

  const controllerProps = useListController({
    resource,
    filter: { projectId },
    sort: { field: 'lastActivityDate', order: 'DESC' },
    perPage: 10,
    disableSyncWithLocation: true
  });

  return (
    <ResourceContextProvider value={resource}>
      <ListContextProvider value={controllerProps}>
        <Datagrid rowClick="edit" bulkActionButtons={false} empty={<></>}>
          <FunctionField
            label="Name"
            source="contactFullName"
            render={(record: { contactId?: number; contactFullName?: string }) => (
              <ContactCellLink record={record} />
            )}
          />
          <TextField source="stage" />
          <DateField source="lastActivityDate" />
          <EditButton />
        </Datagrid>
        <Pagination />
      </ListContextProvider>
    </ResourceContextProvider>
  );
};
